






































































import _ from 'lodash'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Getsudo from '@/tcw/domain/Getsudo'
import {
  ApiGeneralObjectArrayPayload,
  ApiGeneralPayload,
  ApiGeneralSinglePayload,
  ApiPayloadPrimitiveType
} from '@/tcw/api/types'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import * as ApiPath from '@/tcw/constant/ApiPath'
import { TCWBaseError } from '@/plugins/TCWBaseError'

@Component
export default class TeishutsuStatusTable extends Mixins(DataGetComponent) {
  @Prop({ type: Getsudo, default: null })
  private getsudo!: Getsudo | null

  private memberStatusInfo: ApiGeneralSinglePayload | null = null
  private selectedList: ApiGeneralObjectArrayPayload = []

  private get getsudoValue(): Getsudo {
    return this.getsudo ? this.getsudo : Getsudo.now(this.shimebi)
  }
  
  private users: (ApiPayloadPrimitiveType | ApiGeneralSinglePayload)[] = []
  private showFilteredRows = false
  // filteredTeishutsuStatusListメソッド内でusersプロパティをrecords()から取得したデータに変更
  get filteredTeishutsuStatusList(): (ApiPayloadPrimitiveType | ApiGeneralSinglePayload)[] {
    if (this.showFilteredRows) {
      // 退職者表示がONの場合、records()の値を返す
      return this.records
    } else {
      // 退職者表示がOFFの場合
      // taishokuBiがnullかtaishokuBiが提出状況の対象年月以降の行のみを返す
      return this.records.filter(item => {
        // itemがApiGeneralSinglePayload型であるかどうかをチェックする
        if (typeof item === 'object' && item !== null && 'teishutsusha' in item) {
          const teishutsusha = item.teishutsusha
          // teishutsushaがApiGeneralSinglePayload型であるかをチェックする
          if (
            typeof teishutsusha === 'object' &&
            teishutsusha !== null &&
            'taishokuBi' in teishutsusha
          ) {
            // taishokuBiがnullであるかどうかをチェックする
            if (teishutsusha.taishokuBi === null) {
              return true
              // taishokuBiが日付かチェックする
            } else if (
              typeof teishutsusha.taishokuBi === 'string' ||
              typeof teishutsusha.taishokuBi === 'number'
            ) {
              const taishokuBiDate = new Date(teishutsusha.taishokuBi)
              const taishokuBiYear = taishokuBiDate.getFullYear()
              const taishokuBiMonth = taishokuBiDate.getMonth() + 1
              const targetYear = this.getsudoValue.yearValue
              const targetMonth = this.getsudoValue.monthValue
              // taishokuBiが提出状況の対象年月以降かチェックする
              return taishokuBiYear > targetYear || (taishokuBiYear === targetYear && taishokuBiMonth >= targetMonth)
            } else {
              return false
            }
          } else {
            // teishutsushaがApiGeneralSinglePayload型でない場合はフィルタリングしない
            return true
          }
        } else {
          // itemがApiGeneralSinglePayload型でない場合はフィルタリングしない
          return true
        }
      })
    }
  }

  get records(): (ApiPayloadPrimitiveType | ApiGeneralSinglePayload)[] {
    return this.memberStatusInfo && Array.isArray(this.memberStatusInfo.teishutsuInfoList)
      ? this.memberStatusInfo.teishutsuInfoList
      : []
  }

  get apiPath(): string {
    return ApiPath.buildPath(ApiPath.Paths.TeishutsuStatus.get, {
      year: this.getsudoValue.yearValue,
      month: this.getsudoValue.monthValue
    })
  }

  protected responseInitWebApi(response: ApiGeneralPayload): void {
    if (!_.isArray(response)) {
      this.memberStatusInfo = response
    }
  }
  private currentShouninshaName(row: ApiGeneralSinglePayload): string {
    const shouninUserList = row.shouninUserList as ApiGeneralObjectArrayPayload
    if (!_.isArray(shouninUserList)) {
      return ''
    }
    const shouninUserNameList = shouninUserList.map(shounin => shounin.userName)
    return shouninUserNameList.join(',')
  }
  private calcProgress(row: ApiGeneralSinglePayload): number {
    if (!Array.isArray(row.shouninUserList)) {
      return 0
    }
    let [genzaiLevel, maxLevel] = [row.genzaiLevel, row.maxLevel]
    if (typeof genzaiLevel != 'number') {
      genzaiLevel = 0
    }
    if (typeof maxLevel != 'number') {
      maxLevel = 1
    }
    let percentage = (genzaiLevel / maxLevel) * 100
    return Math.round(percentage)
  }
  private async exportExcel(row: ApiGeneralSinglePayload) {
    const teishutsusha = row.teishutsusha
    if (!teishutsusha || typeof teishutsusha != 'object' || Array.isArray(teishutsusha)) {
      this.$tcw.message({
        type: 'error',
        title: 'Excelエクスポートに失敗しました',
        message: 'システム管理者に問い合わせてください'
      })
      return
    }
    try {
      this.isLoading = true
      const path = ApiPath.buildPath(ApiPath.Paths.Export.other, {
        userId: String(teishutsusha.id),
        year: this.getsudoValue.yearValue,
        month: this.getsudoValue.monthValue
      })
      const response = await this.getWebApi().callRaw<string>(
        path,
        'POST',
        {},
        { responseType: 'blob' }
      )

      // ファイルダウンロード処理
      let fileName = this.tcw.getDecodedFileNameFromHeader(response.headers)
      if (fileName === null) {
        fileName = 'TCard_Excel.zip'
      }
      this.tcw.execDownloadFile(fileName, response.data)
    } catch (e) {
      let message = ''
      if (e instanceof TCWBaseError) {
        message = `[${e.getErrorCode()}]${e.outputMessage()}`
      } else {
        message = '不明なエラー'
      }
      this.$tcw.message({
        type: 'error',
        title: 'Exceファイルの取得に失敗しました',
        message
      })
    } finally {
      this.isLoading = false
    }
  }

  private handleSelectionChange(selectedList: ApiGeneralObjectArrayPayload) {
    this.selectedList = selectedList
  }

  private async bulkExport() {
    try {
      this.isLoading = true
      const userIds = this.selectedList.map(
        s => (s.teishutsusha as ApiGeneralSinglePayload)?.id as string
      )
      const path = ApiPath.buildPath(ApiPath.Paths.Export.list, {
        year: this.getsudoValue.yearValue,
        month: this.getsudoValue.monthValue
      })
      const response = await this.getWebApi().callRaw<string>(
        path,
        'POST',
        { userIds },
        { responseType: 'blob' }
      )

      // ファイルダウンロード処理
      let fileName = this.tcw.getDecodedFileNameFromHeader(response.headers)
      if (fileName === null) {
        fileName = 'TCard_Excel.zip'
      }
      this.tcw.execDownloadFile(fileName, response.data)
    } catch (e) {
      let message = ''
      if (e instanceof TCWBaseError) {
        message = `[${e.getErrorCode()}]${e.outputMessage()}`
      } else {
        message = '不明なエラー'
      }
      this.$tcw.message({
        type: 'error',
        title: 'Exceファイルの取得に失敗しました',
        message
      })
    } finally {
      this.isLoading = false
    }
  }
}
